import "./QuizResultsPage.scss";

import { Alert } from "@fluentui/react-northstar";
import React, { useEffect } from "react";
import { useParams } from "react-router";

import { useSurvey } from "../../../_shared/actions/useSurvey";
import { useSurveyResponses } from "../../../_shared/actions/useSurveyResponses";
import { TeamsLoader } from "../../../_shared/components/TeamsLoader";
import { useTeamsContext } from "../../../_shared/state/TeamsContextProvider";
import { QuizResultsDetails } from "./components/quiz/QuizResultsDetails";

export const QuizResultsPage: React.FC = () => {
  const { teamsContext } = useTeamsContext();
  const params = useParams<{ surveyId: string }>();
  const surveyId = decodeURIComponent(params.surveyId);

  const { survey, loadSurvey, isSurveyLoading, surveyError } = useSurvey();
  const { results, loadSurveyResponses, isResponsesLoading, responsesError } = useSurveyResponses();

  useEffect(() => {
    if (teamsContext) {
      loadSurvey(teamsContext, surveyId);
      loadSurveyResponses(teamsContext, surveyId);
    }
  }, [loadSurvey, loadSurveyResponses, surveyId, teamsContext]);

  if (surveyError) {
    return <Alert danger content={surveyError.message} />;
  }

  if (responsesError) {
    return <Alert danger content={responsesError.message} />;
  }

  return (
    <div className="quiz-results-page">
      <TeamsLoader isLoading={isResponsesLoading || isSurveyLoading || !results || !survey}>
        <QuizResultsDetails survey={survey!} results={results!} showPostResultsAction={false} />
      </TeamsLoader>
    </div>
  );
};
